import { LinkProvider, Toasty, TooltipProvider } from '@cloudflare/kumo';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './api.ts';
import { AppErrorBoundary } from './common.tsx';
import { AppLink } from './components/app-link.tsx';
import { router } from './router.tsx';
import { registerWebMcp } from './webmcp.ts';
import './styles.css';

void registerWebMcp().catch((error: unknown) =>
  console.error('WebMCP registration failed:', error instanceof Error ? error.message : 'Unknown error'),
);
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Toasty>
          <LinkProvider component={AppLink}>
            <TooltipProvider>
              <RouterProvider router={router} />
            </TooltipProvider>
          </LinkProvider>
        </Toasty>
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>,
);
